import { panelCountForPanelPage } from '../../store/senAppProjects.action';
import { DrawFence } from '../fence/DrawFence';
import { ScaleAdjustmentValue } from '../getScaleFactor';
import { SC_Input } from '../input/SC_Input';
import { MountingSystem } from '../mountsys/MountingSystem';
import { Sol50 } from '../mountsys/Sol50';
import { getHgroups, sortRows } from '../mountsys/PanelRowManager';
import { SubFrameIn } from '../mountsys/subFrameIn';
import { ModList } from '../panel/ModList';
import { Global } from "../utilities/global";
import { Statics } from '../utilities/statics';
import { ModulProp } from './ModulProp';
import { DrawRoofForPanel } from "./drawRoofForPanel";
import { EllipseError } from './ellipseError';


export default function genaratePanelSave() {
  if (DrawRoofForPanel.isSubframeEnabled) {
    DrawRoofForPanel.isSubframeEnabled = false;
    DrawRoofForPanel.subframeGroup.opacity(0);
    DrawRoofForPanel.subframeGroup.removeChildren();
    DrawRoofForPanel.layerPanel.batchDraw();
  }
  const listOfGroups = getHgroups();
  try {
    if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
      SubFrameIn.getGroups();
    }
    const isMixed: any = (g: any[]) => {
      let mix = false;
      g.forEach((item: any) => {
        if (!mix) mix = item.width != g[0].width;
      });
      return mix;
    }
    if (listOfGroups) {
      const panelRows = listOfGroups.map((item: any) => {
        const w = SC_Input.nModWidth / 10;
        const portraitMode = (w == item[0].width) ? ModulProp.ORIENTATION_VERTICAL : ModulProp.ORIENTATION_HORIZONTAL
        return {
          "panelCount": item.length,
          x: (item[0].x),
          y: (item[0].y),
          "space": Sol50.nHorizontalAbstand,
          "portrait": portraitMode == 1,
          "mixed": isMixed(item)
        }
      });
      Global.panelRows = panelRows;

      Global.hgroups = listOfGroups;
      SC_Input.iModulCount = getPanelCount();
      ModList.iCount = SC_Input.iModulCount;
      if (listOfGroups)
        sortRows(Object.assign([], listOfGroups));

      EllipseError.check_HGroups();
      if (Statics.oCantileverMin && Statics.oCantileverMax && Statics.oVerticalCantileverMax)
        MountingSystem.checkCantilever();
    } else {
      Global.panelRows = [];
      Global.hgroups = [];
      SC_Input.iModulCount = getPanelCount();
      ModList.iCount = SC_Input.iModulCount;
      EllipseError.removeAllEllipse();
    }

  } catch (err) {
    console.log(err)
  }
  ModList.listOfGroups = getHgroups();
  Global.hgroups = getHgroups();
}

export function getPanelCount(fromService?: boolean): number {
  let count = 0;
  if (Global.panelRows && !fromService) {
    Global.panelRows.forEach((item: any) => {
      count += item.panelCount;
    })
  } else if (SC_Input.sPlanDetails && SC_Input.sPlanDetails.panelRows) {
    SC_Input.sPlanDetails.panelRows.forEach((item: any) => {
      count += item.panelCount;
    });
  }
  if (DrawFence.storeObj) {
    DrawFence.storeObj.dispatch(panelCountForPanelPage({ count: count }));
  }
  return count;
}

export function saveNonUsableAreas() {

  // Calculation for nonUsableArea
  let listOfareas: any[] = []
  let areas: any = DrawRoofForPanel.layerPanel.find("." + Global.nonUsableArea);
  listOfareas = areas.map((shape: any) => {

    const s = shape.getAttrs();
    const rect = shape.getClientRect();
    let p = s.points ? s.points : [];
    let f: { x: number; y: number; }[] = []
    for (let i = 0; i < p.length; i = i + 2) {
      f.push(shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] }));
    }
    if (shape.getClassName() === "Line" && shape.getPoints().length == 8) {
      return {
        "type": 2,
        "name": shape.getId(),
        x1: ScaleAdjustmentValue.getOriginalValue(f[0].x),
        y1: ScaleAdjustmentValue.getOriginalValue(f[0].y),
        x2: ScaleAdjustmentValue.getOriginalValue(f[1].x),
        y2: ScaleAdjustmentValue.getOriginalValue(f[1].y),
        x3: ScaleAdjustmentValue.getOriginalValue(f[2].x),
        y3: ScaleAdjustmentValue.getOriginalValue(f[2].y),
        x4: ScaleAdjustmentValue.getOriginalValue(f[3].x),
        y4: ScaleAdjustmentValue.getOriginalValue(f[3].y),
      }
    }
    if (shape.getClassName() === "Line" && shape.getPoints().length == 6) {
      return {
        type: 1,
        name: shape.getId(),
        x1: ScaleAdjustmentValue.getOriginalValue(f[0].x),
        y1: ScaleAdjustmentValue.getOriginalValue(f[0].y),
        x2: ScaleAdjustmentValue.getOriginalValue(f[1].x),
        y2: ScaleAdjustmentValue.getOriginalValue(f[1].y),
        x3: ScaleAdjustmentValue.getOriginalValue(f[2].x),
        y3: ScaleAdjustmentValue.getOriginalValue(f[2].y),
      }
    }
    return {
      type: 3,
      name: shape.getId(),
      x1: ScaleAdjustmentValue.getOriginalValue(rect.x) + ScaleAdjustmentValue.reverseScale(rect.width) / 2,
      y1: ScaleAdjustmentValue.getOriginalValue(rect.y) + ScaleAdjustmentValue.reverseScale(rect.width) / 2,
      radius: ScaleAdjustmentValue.reverseScale(rect.width) / 2
    }
  });
  Global.roofObstructions = listOfareas;
}